import { CircleHelp } from 'lucide-react';
import { useFieldTerm, useTermResolve } from './api';
import { TermTrigger } from './TermPopover';

export type TermHintProps = {
  /** Ключ поля інтерфейсу (див. fieldTerms.ts), напр. 'content.material.commercialValue' чи customFieldKey('Портрет клієнта'). */
  fieldKey?: string;
  /** Термін напряму (має перевагу над fieldKey), напр. 'КЦ'. */
  term?: string;
  /** Підпис поля для aria-label «Що означає «…»?»; типово — сам термін. */
  label?: string;
};

/**
 * Значок «?» поряд із підписом поля: наведення, фокус чи клік показують коротку картку поняття
 * з посиланням на «Довідник понять». Якщо поняття не знайдено (або довідник недоступний) — нічого не рендерить.
 */
export function TermHint({ fieldKey, term, label }: TermHintProps) {
  const explicit = term?.trim() || null;
  const fromField = useFieldTerm(explicit ? null : fieldKey);
  const resolved = useTermResolve(explicit ?? fromField);
  const concept = resolved.data?.canonical ?? null;
  if (!concept) return null;
  const name = label?.trim() || concept.term;
  return (
    <TermTrigger
      term={concept}
      ariaLabel={`Що означає «${name}»?`}
      className="relative -my-0.5 inline-flex size-5 shrink-0 items-center justify-center rounded-xs text-fg-3 transition-colors duration-150 after:absolute after:-inset-1 after:content-[''] hover:bg-surface-2 hover:text-fg-2 aria-expanded:text-fg"
    >
      <CircleHelp className="size-3.5" strokeWidth={2} aria-hidden />
    </TermTrigger>
  );
}
